import { DiwaAPI } from './client'

/** Uncertain evidence waiting on judgment — enrichment matches now, more kinds later. */
export interface Suggestion {
  id: string
  kind: string
  status: 'open' | 'accepted' | 'rejected'
  subject_type: string
  subject_id: string | null
  title: string
  payload: {
    normalized?: Record<string, string>
    source?: string
    match_strength?: string
  }
  created_at: string
}

export class SuggestionsAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  list(status: 'open' | 'accepted' | 'rejected' = 'open'): Promise<Suggestion[]> {
    return this.api.get<Suggestion[]>(`/suggestions?status=${status}`)
  }

  /** Accept applies the proposed write; reject resolves without touching the graph. */
  resolve(id: string, decision: 'accept' | 'reject'): Promise<{ resolved: boolean; status: string }> {
    return this.api.post<{ resolved: boolean; status: string }>(`/suggestions/${id}/resolve`, {
      decision,
    })
  }
}
